export default __webpack_public_path__ + "static/media/membre_nadir.eec0f6aa.JPG";